import { TyRegion } from '../types';
import { KPContentType } from '../types/contentStackRef';
import { REGION_MAP } from './regionUtils';

const REFS = {
  HOME: ['carousel', 'carousel.items', 'faq_va.faqs'],
};
type PageKeys = {
  contentType: string;
  slug: string;
  refs: string[];
  region: string;
  additionalQueryParams?: any;
  hasMarketingContent?: boolean;
  all?: boolean;
};
export const PAGE_MAP: {
  [url: string]: {
    refs: string[];
    contentType: string;
    hasMarketingContent?: boolean;
    isNational?: boolean;
    all?: boolean;
    additionalQueryParams?: any;
  };
} = {
  '/': {
    contentType: KPContentType.Page,
    refs: REFS.HOME,
  },
  '/secure': {
    contentType: KPContentType.Page,
    refs: REFS.HOME,
  },
  '/login': {
    contentType: KPContentType.Page,
    refs: [],
  },
  '/logout': {
    contentType: KPContentType.Page,
    refs: [],
  },
  '/contactus': {
    contentType: KPContentType.ContactUs,
    refs: [KPContentType.ContactUsTile, KPContentType.ContactUsCardGroup],
  },
  '/bookEyeExam': {
    contentType: KPContentType.Page,
    refs: [],
  },
  '/returns': {
    contentType: KPContentType.ArticlePage,
    refs: [KPContentType.Banner, KPContentType.ArticlePageNavigationButtons],
  },
  '/guarantees': {
    contentType: KPContentType.ArticlePage,
    refs: [KPContentType.Banner, KPContentType.ArticlePageStepByStep],
  },
  '/shoponline': {
    contentType: KPContentType.ArticlePage,
    refs: [KPContentType.Banner, KPContentType.ArticlePageStepByStep, KPContentType.ArticlePageStepByStepNavigationButtons],
  },
  '/howtoreadrx': {
    contentType: KPContentType.ArticlePage,
    refs: [
      KPContentType.Banner,
      KPContentType.ArticleDynamicData,
      KPContentType.ArticleDynamicDataTable,
      KPContentType.ArticleDynamicDataNav,
      KPContentType.ArticleDynamicDataImg,
    ],
  },
  '/trunkshow': {
    contentType: KPContentType.ArticlePage,
    refs: [KPContentType.Banner, KPContentType.ArticleContentBanners],
  },
  '/rebates': {
    contentType: KPContentType.ArticlePage,
    refs: [
      KPContentType.Banner,
      KPContentType.ArticlePageRebates,
      KPContentType.ArticleContentBanners,
    ],
  },
  '/visit': {
    contentType: KPContentType.ArticlePage,
    refs: [KPContentType.Banner, KPContentType.ArticlePageStepByStep],
  },
  '/privacy': {
    contentType: KPContentType.ArticlePage,
    refs: [KPContentType.Banner],
  },
  '/consumer-termsconditions': {
    contentType: KPContentType.ArticlePage,
    refs: [KPContentType.Banner],
  },
  '/aboutus': {
    contentType: KPContentType.ArticlePage,
    refs: [
      KPContentType.Banner,
      KPContentType.ArticlePageNavigationButtons,
      KPContentType.ArticleContentBanners,
    ],
  },
  '/faqs': {
    contentType: KPContentType.FAQsPage,
    isNational: false,
    refs: [
      KPContentType.FAQsAccordion,
      KPContentType.ContactUsTile,
      KPContentType.ContactUsCardGroup,
    ],
  },
  '/eyecareinformation': {
    contentType: KPContentType.ArticlePage,
    refs: [KPContentType.Banner],
  },
  '/secure/bookappointment': {
    contentType: KPContentType.ArticlePage,
    refs: [KPContentType.Banner],
  },
  '/secure/bookOpticalAppointment': {
    contentType: KPContentType.ArticlePage,
    refs: [KPContentType.Banner],
  },
  '/glasses/learn/opticalbenefits': {
    contentType: KPContentType.ArticlePage,
    refs: [
      KPContentType.Banner,
      KPContentType.ArticlePageStepByStep,
      KPContentType.ArticlePageStepByStepNavigationButtons,
    ],
  },
  '/store/locations': {
    contentType: KPContentType.FindLocation,
    refs: [KPContentType.Banner],
  },
  '/secure/account': {
    contentType: KPContentType.UserAccount,
    refs: [KPContentType.AccountTab, KPContentType.BenefitTables, KPContentType.OrderHistory],
  },
  '/secure/account/orders': {
    contentType: KPContentType.UserAccount,
    refs: [KPContentType.OrderHistory, KPContentType.AccountTab],
  },
  '/secure/account/cancelOrder': {
    contentType: KPContentType.CancelOrder,
    refs: [],
  },
  '/secure/account/orderDetails': {
    contentType: KPContentType.UserAccount,
    refs: [KPContentType.OrderHistory, KPContentType.AccountTab],
  },
  '/secure/order/contact-lenses': {
    contentType: KPContentType.ContactsPDPPage,
    refs: [
      KPContentType.ProductFeature,
      KPContentType.AccountTab,
      KPContentType.OpticalBenefits,
      KPContentType.AboutBrand,
      KPContentType.ClAttributesNamingMap,
    ],
  },
  '/secure/order-confirmation': {
    contentType: KPContentType.PDPPage,
    refs: [KPContentType.ProductGrid],
  },
  '/secure/account/benefits': {
    contentType: KPContentType.UserAccount,
    refs: [
      KPContentType.AccountTab,
      KPContentType.BenefitTables,
      KPContentType.ProtectionAndSavingsPlan,
    ],
  },
  '/secure/account/rx': {
    contentType: KPContentType.UserAccount,
    refs: [KPContentType.AccountTab],
  },
  '/secure/account/favorites': {
    contentType: KPContentType.UserAccount,
    refs: [KPContentType.AccountTab],
  },
  '/secure/account/savedForLater': {
    contentType: KPContentType.UserAccount,
    refs: [KPContentType.AccountTab],
  },
  '/secure/account/address': {
    contentType: KPContentType.UserAccount,
    refs: [KPContentType.AccountTab],
  },
  '/secure/account/personal': {
    contentType: KPContentType.UserAccount,
    refs: [KPContentType.AccountTab],
  },
  '/glasses': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/eyeglasses': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/eyeglasses/men': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/sunglasses/men': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/eyeglasses/women': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/sunglasses/women': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/eyeglasses/youth': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/eyeglasses/savings-plan': {
    contentType: KPContentType.PLPPage,
    refs: [],
  },
  '/glasses/eyeglasses/promotions': {
    contentType: KPContentType.PLPPage,
    refs: [],
  },
  '/glasses/sunglasses/savings-plan': {
    contentType: KPContentType.PLPPage,
    refs: [],
  },
  '/glasses/sunglasses/promotions': {
    contentType: KPContentType.PLPPage,
    refs: [],
  },
  '/glasses/sunglasses/youth': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/eyeglasses/under-50': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/sunglasses/under-50': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/sunglasses': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/brands': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/glasses/frames/pdp': {
    contentType: KPContentType.PDPPage,
    refs: [
      KPContentType.StoreAvailability,
      KPContentType.OurGuarantees,
      KPContentType.OpticalBenefits,
      KPContentType.AboutBrand,
      KPContentType.AccountTab,
      KPContentType.BenefitTables,
      KPContentType.ProductFeature,
    ],
  },
  '/contact-lenses/pdp': {
    contentType: KPContentType.ContactsPDPPage,
    refs: [
      KPContentType.ProductFeature,
      KPContentType.OpticalBenefits,
      KPContentType.AboutBrand,
      KPContentType.AnnualSupplyDiscount,
      KPContentType.BenefitTables,
    ],
  },
  '/contact-lenses': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/contact-lenses/promotion-rebates': {
    contentType: KPContentType.PLPPage,
    refs: [],
  },
  '/contact-lenses/savings-plan': {
    contentType: KPContentType.PLPPage,
    refs: [],
  },
  '/learn-more': {
    contentType: KPContentType.PLPPage,
    refs: [],
  },
  '/cart': {
    contentType: KPContentType.CartPage,
    refs: [
      KPContentType.OurGuarantees,
      KPContentType.ProtectionAndSavingsPlan,
      KPContentType.ProductFeature,
      KPContentType.BenefitTables,
    ],
    hasMarketingContent: true,
  },
  '/secure/cart': {
    contentType: KPContentType.CartPage,
    refs: [
      KPContentType.OurGuarantees,
      KPContentType.ProtectionAndSavingsPlan,
      KPContentType.ProductFeature,
      KPContentType.BenefitTables,
    ],
    hasMarketingContent: true,
  },
  '/secure/glasses/lenses': {
    contentType: KPContentType.LensWizardPage,
    refs: [KPContentType.LensWizardStep],
  },
  '/search': {
    contentType: KPContentType.PLPPage,
    refs: [KPContentType.Banner, KPContentType.ProductGrid],
  },
  '/secure/contactus': {
    contentType: KPContentType.ContactUs,
    refs: [KPContentType.ContactUsTile, KPContentType.ContactUsCardGroup],
  },
  '/secure/addFavorite': {
    contentType: KPContentType.AddFavorite,
    refs: [],
  },
  '/secure/contactsSigninPdp': {
    contentType: KPContentType.ContactsSigninPdp,
    refs: [],
  },
  '/secure/framesPDP': {
    contentType: KPContentType.Page,
    refs: [],
  },
};

export function getPageKeys(location: Location, pageSlugCd: string): PageKeys | null {
  const pathVars = location.pathname.split('/');
  let region = REGION_MAP[pathVars[1]?.toUpperCase() as TyRegion];
  let slug = '/' + pathVars.slice(2).join('/');
  // Both '/' & '/secure' to ponnt to same Home page One is Secure other one is insecure'
  slug = slug === '/secure/home' ? '/' : slug;

  let pageConfig = PAGE_MAP[slug];

  if (!pageConfig && pageSlugCd) {
    // Remove region from the slug
    slug = pageSlugCd.replace('/:region', '');
    pageConfig = PAGE_MAP[slug];
  }

  if (!PAGE_MAP[slug]) return null;
  const { refs, contentType, hasMarketingContent, all, additionalQueryParams, isNational } =
    PAGE_MAP[slug];
  // Is Page Content Defined at National Level
  if (isNational) {
    region = 'NAT';
  }
  const pageKeys: PageKeys = {
    slug,
    refs,
    region,
    contentType,
    hasMarketingContent,
    additionalQueryParams,
    all,
  };
  return pageKeys;
}
